document.addEventListener('DOMContentLoaded', () => {

  const isMobile = (window.matchMedia("(max-width: 767px)").matches) ? true : false;
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  const bodyElement = document.body;

  if( isSafari ) {
    document.body.classList.add('safari');
  }

  // header-section
  const observerHeader = new MutationObserver((mutationsList, observer) => {
    const headerSection = document.querySelector('.header-section');
    if( headerSection ) {
      headerSection.style.visibility = 'visible';
      observerHeader.disconnect();
    }
  });
  observerHeader.observe(document.body, { childList: true, subtree: true }); 

  // Announcement
  const observerAnnouncement = new MutationObserver((mutationsList, observer) => {
    const announcementBar = document.querySelector('.announcement-bar-section');
    if( announcementBar ) {

      window.addEventListener('scroll', function() {
        
        const headerSection = document.querySelector('.header-section');
        if( headerSection ) {
          headerSection.style.top = ( window.scrollY <= announcementBar.offsetHeight ) ? announcementBar.offsetHeight + 'px' : '0';
        }
      }, {
        passive: true
      });
      window.dispatchEvent(new Event('scroll'));
      
      observerAnnouncement.disconnect();
    }
  });
  observerAnnouncement.observe(document.body, { childList: true, subtree: true }); 
  
  // Burger Menu on hover
  const mobileToggle = document.querySelector('.full-menu--toggle.mobile-toggle');
  if( mobileToggle ) {
    mobileToggle.addEventListener('mouseover', function() {
      mobileToggle.click();
    });
  }

  // Hide menu title on hover
  const menuLinks = document.querySelectorAll('.full-menu a[title]');
  if( menuLinks ) {
    menuLinks.forEach(link => {
        link.addEventListener('mouseenter', () => {
            link.setAttribute('data-title', link.getAttribute('title'));
            link.removeAttribute('title');
        });
    
        link.addEventListener('mouseleave', () => {
            link.setAttribute('title', link.getAttribute('data-title'));
            link.removeAttribute('data-title');
        });
    });
  }

  // Dark footer for sfilata-collezioni-2025 and for homepage
  const body = document.body;
  if (body.className.includes('template-page-ecom-sfilata-collezioni-2025') || body.className.includes('template-index') ) {

    const root = document.documentElement;
    root.style.setProperty('--color-footer-bg', '#000000');
    root.style.setProperty('--color-footer-link', '#ffffff');
    root.style.setProperty('--color-footer-text', '#ffffff');
    root.style.setProperty('--color-footer-heading', '#9e9e9e');
    root.style.setProperty('--color-footer-border', '#2e2e2d');

    if( document.querySelector('.footer-email-bar .h4') ) {
      document.querySelector('.footer-email-bar .h4').style.color = '#ffffff';
    }
    
    const inputElements = document.querySelectorAll('input');
    inputElements.forEach(inputElement => {
      
      if (inputElement.id.startsWith('NewsletterForm--sections-')) {
        inputElement.style.background = '#000000';
        inputElement.style.color = '#ffffff';
      }
    });

    const logoImg = document.querySelector('.footer .small-12.columns img');
    const headerLogoLight = document.querySelector('.logoimg--light');

    if( logoImg && headerLogoLight ) {

      // logoImg.src = logoImg.src.replace('black', 'White');
      logoImg.src = headerLogoLight.src;

      const observerFooteLogo = new MutationObserver((mutationsList) => {
        for (let mutation of mutationsList) {
          if (mutation.type === "attributes" && mutation.attributeName === "srcset") {
            logoImg.removeAttribute("srcset");
            logoImg.src = headerLogoLight.src;
          }
        }
      });
      observerFooteLogo.observe(logoImg, { attributes: true });
      // setTimeout(() => {
      //     observerFooteLogo.disconnect();
      // }, 10000);
    }
  }

  // Home: Instagram widget disable scrolling when active  
  function preventDefault(e) {
    e.preventDefault();
  }

  function disableScroll() {
    document.addEventListener('wheel', preventDefault, { passive: false });
    document.addEventListener('touchmove', preventDefault, { passive: false });
  }

  function enableScroll() {
    document.removeEventListener('wheel', preventDefault);
    document.removeEventListener('touchmove', preventDefault);
  }

  const observerInstagram = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        const element = document.querySelector('.sw-instagram-modal.is-active');
        if (element) {
          disableScroll();
          // observerInstagram.disconnect();

          // Home: Instagram widget hide video controls
          const swCarouselList = document.querySelector('.sw-carousel-list');
          if( swCarouselList ) {
            const videoElements = swCarouselList.getElementsByTagName('video'); 
            for (var i = 0; i < videoElements.length; i++) {
              videoElements[i].controls = false; 
              videoElements[i].loop = true; 
              if(window.matchMedia("(max-width: 767px)").matches) {
                videoElements[i].pause();
              } else {
                videoElements[i].play();
              }
            }
          }
        } else {
          enableScroll();
        }
      }
    }
  });
  observerInstagram.observe(document.body, { childList: true, subtree: true });
  
  // FOOTER
  let chck_if_footer_loaded = setInterval( function() {

     // Weglot
    if (typeof Weglot !== 'undefined') {
      
      function CustomTranslate() {
        
        Weglot.translate(
            {
              'words':[
                { "t":1,"w": "Sfoglia il catalogo" },
                { "t":1,"w": "Scopri di più" },
                { "t":1,"w": "Prenota un appuntamento" },
                { "t":1,"w": "Trova lo store più vicino" },
                { "t":1,"w": "SCOPRI LA NOSTRA COLLEZIONE" },
                { "t":1,"w": "Accedi" },
                { "t":1,"w": "Inizia a fare acquisti" },
                { "t":1,"w": "Scopri la collezione" },
                { "t":1,"w": "Trova un negozio" },
                { "t":1,"w": "Aggiungi al carrello" },
                { "t":1,"w": "Inserisci indirizzo o codice postale" },
              ],
              'languageTo': Weglot.getCurrentLang()  
            } 
            , function(data) {
  
              // console.log(data)
              
              // Browse the Catalog
              const elementsBrowseCatalog = document.querySelectorAll('[data-content="Sfoglia il catalogo"]');
              if( elementsBrowseCatalog ) {
                elementsBrowseCatalog.forEach(element => {
                  if( data[0] && data[0] !== '' )
                    element.setAttribute('data-content', data[0]);
                });
              }
              
              // Discover More
              const elementsDiscoverMore = document.querySelectorAll('[data-content="SCOPRI DI PIÙ"]');
              if( elementsDiscoverMore ) {
                elementsDiscoverMore.forEach(element => {
                  if( data[1] && data[1] !== '' )
                    element.setAttribute('data-content', data[1]);
                });
              }
  
              // Book an appointment
              const elementsBookAppointment = document.querySelectorAll('a.button[href*="/pages/tailor-made"]');
              if( elementsBookAppointment ) {
                elementsBookAppointment.forEach(element => {
                  if( data[2] && data[2] !== '' )
                    element.querySelector('span').setAttribute('data-content', data[2]);
                });
              }
              
              // Find the closest store
              const elementsFindClosestStore = document.querySelectorAll('.gallery--item-content a.button[href="/pages/store-locator-1"]');
              if( elementsFindClosestStore ) {
                elementsFindClosestStore.forEach(element => {
                  if( data[3] && data[3] !== '' )
                    element.querySelector('span').setAttribute('data-content', data[3]);
                });
              }
  
              // Discover our Collection
              const elementsDiscoverOutCollection = document.querySelectorAll('[data-content="SCOPRI LA NOSTRA COLLEZIONE"]');
              if( elementsDiscoverOutCollection ) {
                elementsDiscoverOutCollection.forEach(element => {
                  if( data[4] && data[4] !== '' )
                    element.setAttribute('data-content', data[4]);
                });
              }
  
              // Accedi
              const elementsAccedi = document.querySelectorAll('[action="/account/login"] button');
              if( elementsAccedi ) {
                elementsAccedi.forEach(element => {
                  if( data[5] && data[5] !== '' )
                    element.querySelector('span').setAttribute('data-content', data[5]);
                });
              }
  
              // Inizia a fare acquisti
              const elementsStartShopping = document.querySelectorAll('a.button[href*="/collections/all"]');
              if( elementsStartShopping ) {
                elementsStartShopping.forEach(element => {
                  if( data[6] && data[6] !== '' )
                    element.querySelector('span').setAttribute('data-content', data[6]);
                });
              }
  
              // Discover the Collection
              const elementsDiscoverCollection = document.querySelectorAll('a.button[href*="/pages/catalogo-anteprima-2025"]');
              if( elementsDiscoverCollection ) {
                elementsDiscoverCollection.forEach(element => {
                  if( data[7] && data[7] !== '' )
                    element.querySelector('span').setAttribute('data-content', data[7]);
                });
              }
  
              // Find a Store
              const elementsFindStore = document.querySelectorAll('a.button[href*="/pages/store-locator-1"]');
              if( elementsFindStore ) {
                elementsFindStore.forEach(element => {
                  if( data[8] && data[8] !== '' )
                    element.querySelector('span').setAttribute('data-content', data[8]);
                });
              }
  
              // Add to cart
              const elementsAdd2cart = document.querySelectorAll('.single-add-to-cart-button--text');
              if( elementsAdd2cart ) {
                elementsAdd2cart.forEach(element => {
                  if( data[9] && data[9] !== '' )
                    element.setAttribute('data-content', data[9]);
                    if( theme && theme.variantStrings ) {
                      theme.variantStrings.addToCart = data[9];
                    }
                });
              }
          });
      }
      CustomTranslate();

      // Product variation select
      // const variationRadioButtons = document.querySelectorAll('.variations input[type="radio"]');
      // if( variationRadioButtons ) {
      //   variationRadioButtons.forEach(radioButton => {
      //     radioButton.addEventListener('change', function() {
      //       CustomTranslate();
      //     });
      //   });
      // }
    }

    const footer = document.querySelector('footer');
    
    if( footer ) {   
      
      const weglotSwitcher = document.querySelector('.weglot-container');
      
      if( weglotSwitcher ) {
        
        // Menu Weglot
        if( Weglot ) {

          const weglotMenuSwitchers = document.querySelectorAll('.menu-weglot-switcher');
          const wgFlagImgs = document.querySelectorAll('.menu-weglot-switcher img');

          let availableLanguages = Weglot.options.languages
            .map(function(language) {
                return language.language_to;
            })
            .concat(Weglot.options.language_from);
          let currentLang = Weglot.getCurrentLang();          
          
          weglotMenuSwitchers.forEach(weglotMenuSwitcher => {

            if( !weglotMenuSwitcher.querySelector('select') ) {

              var selectList = document.createElement("select");
              weglotMenuSwitcher.appendChild(selectList);
              for (var i = 0; i < availableLanguages.length; i++) {
                var lang = availableLanguages[i];
                var option = document.createElement("option");
                option.value = lang;
                option.text = Weglot.getLanguageName(lang);
                if (lang === currentLang) {
                  option.selected = "selected";
                  setWGFlag(lang);
                  // submitLocalizationForm(lang);
                }
                selectList.appendChild(option);
              }
              
              selectList.onchange = function(){
                const selectedValue = this.value;
                Weglot.switchTo(selectedValue);
                setWGFlag(selectedValue);
                CustomTranslate();
              };
  
              // Weglot.on("languageChanged", function(lang) {
              //   selectList.value = lang;
              //   setWGFlag(lang);
              // });
            }
          });

          function submitLocalizationForm(lang) {
            
            const localizationForm = document.querySelector('.shopify-localization-form');
            lang = lang.indexOf('en') !== -1 ? 'GB' : lang;
            setTimeout(()=> {
              if( localizationForm ) {
                // localizationForm.querySelector('.thb-currency-code').value = lang.toUpperCase();
                // localizationForm.submit();
              }
            }, 2000);
          }
          
          function setWGFlag(l) {
            wgFlagImgs.forEach(wgFlagImg => {
              l = l == 'en' ? 'gb' : l;
              wgFlagImg.src = 'https://cdn.weglot.com/flags/circle/'+ l +'.svg';
            });
          }
          
          clearInterval( chck_if_footer_loaded );

        }
      }
  
      // const footerCollapsibleItems = footer.querySelectorAll('.thb-widget-title.collapsible');
      // if( footerCollapsibleItems ) {
      //   footerCollapsibleItems.forEach(function(item) {
      //     item.classList.add('active');
      //   });
      // }
    }
  }, 100);

  // Add target="_blank" to a on picky bundle 
  if( bodyElement.classList.contains('template-product-picky-bundle') ) {
    let elements = document.querySelectorAll('.scrolling-boxes--box a.text-button');
    for (var i = 0; i < elements.length; i++) {
      elements[i].setAttribute('target', '_blank');
    }
  }

  // Product-Drawer play product video on open
  const productDrawer = document.querySelector('.product-drawer');
  
  if (productDrawer) {
    const observerProductDrawer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'class') {
          if (productDrawer.classList.contains('active')) {
            // console.log('Product drawer opened');
            const productDrawerVideo = productDrawer.querySelector('video');
            if (productDrawerVideo && productDrawer.classList.contains('active')) {
              productDrawerVideo.addEventListener('pause', function() {
                productDrawerVideo.currentTime = 0;
                productDrawerVideo.play();
              });
            }
          } else {
            // console.log('Product drawer closed');
          }
        }
      });
    });
  
    observerProductDrawer.observe(productDrawer, { attributes: true });
  }

  // document.addEventListener('quick-view:open', function(event) {
  //   if (event.detail.productHandle) {
  //   }
  // });


  // SIZES ORDER ON BUNDLE PRODUCT
  function sortSelectOptions() {

    const pickyBundle = document.querySelector('.picky-bnd-bundle');
    if( pickyBundle ) {
     
      const selects = pickyBundle.querySelectorAll('select');
      if( selects ) {
        
        selects.forEach(select => {
          const optionsArray = Array.from(select.options);  
          optionsArray.sort((a, b) => a.text.localeCompare(b.text));        
          select.innerHTML = "";
          optionsArray.forEach(option => select.appendChild(option));      
        }); 
      }
    }
  }
  const observerPickyBundle = new MutationObserver((mutationsList, observer) => {
    const selectBox = document.querySelector('.picky-bnd-bundle');
    if (selectBox) {
        sortSelectOptions();

        // TOTAL LOOK PDP ISSUE
        if (typeof ScrollTrigger !== 'undefined') {
          ScrollTrigger.refresh();
        }
        observerPickyBundle.disconnect();
    }
  });
  observerPickyBundle.observe(document.body, { childList: true, subtree: true });  

  // 
  if( body.classList.contains('template-article') && isMobile ) {

    const parallaxElements = document.querySelectorAll('.ecom-parallax-background');

    function handleParallax() {
      const scrollPosition = window.scrollY;
      parallaxElements.forEach(element => {
          const speed = element.dataset.speed || 0.5;
          const imgSrc = element.querySelector('img').src
          const imgTop = element.querySelector('img').style.top;
        
          // element.style.backgroundPositionY = imgTop;
          // element.style.backgroundImage = `url(${imgSrc})`;
      });
    }
    // window.addEventListener('scroll', handleParallax);
  }

  // Fallback Image 4 background <video>  
  // const videoBGContact = document.querySelectorAll('.template-page-ecom-contattaci .ecom-video-background');

  // if( videoBGContact ) {

    // const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection || {};
    // const saveData = connection.saveData || false;
    // const slowConnection = ['slow-2g', '2g', '3g'].includes(connection.effectiveType);
    // const supportsPrefersReducedData = window.matchMedia('not all and (prefers-reduced-data), (prefers-reduced-data)').matches;
    // const noPreference = window.matchMedia('(prefers-reduced-data: no-preference)').matches;
    // const canAutoPlayAndPreload = !supportsPrefersReducedData || (supportsPrefersReducedData && noPreference) || saveData || slowConnection;

    // videoBGContact.forEach(videoElement => {      

    //   // let src = videoElement.getAttribute('src');
    //   // videoElement.removeAttribute('controls');
    //   // videoElement.controls = false;
    //   // videoElement.removeAttribute('preload');

    //   // videoElement.setAttribute('poster', 'https://fastly.picsum.photos/id/32/4032/3024.jpg?hmac=n7I3OdGszMIwuGcvplNthgBmAxvAZ3rNBBSuDFZaItQ');
      
    //   if (canAutoPlayAndPreload && (window.matchMedia("(max-width: 1024px)").matches) ) {
    //     // videoElement.style.display = 'none';
    //     // videoElement.parentNode.parentNode.style.backgroundImage = 'url("https://fastly.picsum.photos/id/32/4032/3024.jpg?hmac=n7I3OdGszMIwuGcvplNthgBmAxvAZ3rNBBSuDFZaItQ")';
    //   }
            
    //   // Prevent right-click context menu (optional)
    //   videoElement.addEventListener('contextmenu', (e) => e.preventDefault());

    //   videoElement.addEventListener("canplay", (event) => {
    //     // videoElement.play();
    //     videoElement.removeAttribute('controls');
    //   });

    // })
    
  // alert(navigator?.userAgent || "Navigator object or userAgent not available.");
    
    // if (navigator.getBattery) {
    //   navigator.getBattery().then(battery => {
    //     // battery.saveMode
    //       videoBGContact.style.display = 'none';
    //       videoBGContact.parentNode.parentNode.style.backgroundImage = 'url("https://fastly.picsum.photos/id/32/4032/3024.jpg?hmac=n7I3OdGszMIwuGcvplNthgBmAxvAZ3rNBBSuDFZaItQ")';
    //   });
    // }
  // }


  // Newsletter popup
  const openNewsletter = document.querySelector('.open-newsletter-form');
  if( openNewsletter ) {

    openNewsletter.addEventListener('click', function(event){

      const mc_modal = document.querySelector('.mc-modal');
      if( mc_modal ) {
         mc_modal.classList.add('active');
      }

      // this.classList.add('hide');

    });
  } 

  // Mailchimp Popup styling  
  const checkMC = setInterval(() => {
    
    const mc = document.querySelector('.mc-layout__modalContent');
    const mcModal = document.querySelector('.mc-modal');
    
    if( mc ) {

      // new close btn
      mcModal.insertAdjacentHTML('afterbegin', '<div class="closeMC"><svg width="24" height="24" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path d="M9.33337 9.33341L22.6667 22.6667M9.33337 22.6667L22.6667 9.33333" stroke="rgba(0,0,0,1)" stroke-width="3" stroke-linecap="round"></path></svg></div>');
      const closeMC = document.querySelector('.closeMC');
      if( closeMC ) {
        closeMC.addEventListener('click', function(event){
          const mc_modal = document.querySelector('.mc-modal');
          mc_modal.classList.remove('active');
        });
      }

      mc.classList.add('active');
      const mcIframe = mc.querySelector('iframe');
      if( mcIframe ) {
        let iframeDoc = mcIframe.contentDocument || mcIframe.contentWindow.document;

        if( iframeDoc ) {

          iframeDoc.body.style.overflowY = 'auto';

          const style = iframeDoc.createElement('style');
          style.textContent = `
            @font-face {
              font-family: 'Optima LT Pro';
              src: url('https://carlopignatelli.com/cdn/shop/files/OptimaLTPro-Roman.woff2') format('woff2'),
                   url('https://carlopignatelli.com/cdn/shop/files/OptimaLTPro-Roman.woff') format('woff');
              font-weight: normal;
              font-style: normal;
            }

            .content__titleDescription > div> p:first-child {
              margin-bottom: 0.5em;
            }
            .content__titleDescription h2 {
              margin-bottom: 1.5rem;
            }
            .content__titleDescription h3 {
              text-transform: lowercase;
              margin-top: 1rem;
            }
            .content__titleDescription h3::first-letter {
              text-transform: capitalize;
            }
          `;
          iframeDoc.head.appendChild(style);
          
          let iframeContent = iframeDoc.querySelector('.modalContent__content');

          if( iframeContent ) {

            // openNewsletter.classList.remove('hide');
            
            const checkboxGDPR = iframeDoc.querySelector('input[type="checkbox"]');
            if( checkboxGDPR ) {
              checkboxGDPR.required = true;
            }

            iframeContent.style.cssText = isMobile ? 'padding: 30px 15px;' : 'padding: 30px;';
          
            const paragraphs = iframeContent.querySelectorAll('p');
            if( paragraphs ) {
              paragraphs.forEach(paragraph => {    
                paragraph.style.cssText = "font-family: 'Open Sans', serif !important; font-size: 14px !important; font-weight: normal !important; line-height: 1.2 !important; text-align: center;";
              });
            }

            const labels = iframeContent.querySelectorAll('label');
            if( labels ) {
              labels.forEach(label => {    
                label.style.cssText = "font-family: 'Open Sans', serif !important; font-size: 14px !important; font-weight: normal !important; line-height: 1.2 !important;";
              });
            }
            
            const inputs = iframeContent.querySelectorAll('input:not([type="radio"]');
            if( inputs ) {
              inputs.forEach(input => {          
                input.style.cssText = "min-height: 2.5rem !important; font-family: 'Open Sans', serif !important; font-size: 14px !important; font-weight: normal !important; line-height: 1 !important; border-radius: 0 !important; border-color: #000 !important; border-width: 1px !important; outline: none;";
              });
            }

            const fieldWrappers = iframeContent.querySelectorAll('.field-wrapper');
            if( fieldWrappers ) {
              fieldWrappers.forEach(wrapper => {          
                wrapper.style.cssText = "margin: 0 0 15px !important;";
              });
            }

            const fieldWrappersLangs = iframeContent.querySelector('.field-wrapper.radio-group');
            if( fieldWrappersLangs ) {
              fieldWrappersLangs.style.cssText = "order: -1; text-align: center; margin: 0 0 15px !important;";
            }

            const checkboxContainer = iframeContent.querySelector('ul.radioCheckboxContainer');
            if( checkboxContainer ) {
              checkboxContainer.style.cssText = "display: flex; align-items: center; gap: 1.5rem; justify-content: center;";
            }

            const lis = iframeContent.querySelectorAll('li');
            if( lis ) {
              lis.forEach(li => {
                
                li.style.cssText = "display: flex; justify-content: center;";
                
                const liLabel = li.querySelector('label');
                if( liLabel ) {
                  liLabel.style.cssText = "padding: 0 !important; font-family: 'Open Sans', serif !important; font-size: 14px !important; font-weight: normal !important; line-height: 1.2 !important;";
                }
              });
            }
            
            const headings = iframeContent.querySelectorAll('h2, h3');
            if( headings ) {
              headings.forEach(heading => {
                const fontSizeH = isMobile ? '18px' : '30px';
                heading.style.cssText = "line-height: 1; text-align: center; font-family: 'Optima LT Pro', serif !important; font-size: "+ fontSizeH +" !important;";
              });
            }

            const contentFormFields = iframeContent.querySelector('.content__formFields');
            if( contentFormFields ) {
              contentFormFields.style.cssText = "display: flex; flex-direction: column;";
            }

            const GdprFieldWrapper = iframeContent.querySelector('.content__gdprFields > li.field-wrapper');
            if( GdprFieldWrapper ) {
              GdprFieldWrapper.style.cssText = "display: block !important; margin: 0 !important;";

              GdprFieldWrapper.querySelector('span').style.cssText = "font-size: 12px !important;";
              GdprFieldWrapper.querySelector('input[type="checkbox"]').style.cssText = "min-height: auto !important;";
              // GdprFieldWrapper.querySelector('input[type="checkbox"]:checked').style.cssText = "accent-color: #000 !important;";
            }
            
            const contentGdprLegal = iframeContent.querySelector('.content__gdprLegal');
            if( contentGdprLegal ) {
              contentGdprLegal.style.cssText = "display: none !important;";
            }

            const contentGdpr = iframeContent.querySelector('.content__gdpr');
            if( contentGdpr ) {
              contentGdpr.style.cssText = "padding-top: 0 !important;";
            }              

            const contentGdprLabel = iframeContent.querySelector('.content__gdpr > label');
            if( contentGdprLabel ) {
              contentGdprLabel.style.cssText = "display: none !important;";
            }

            const contentGdprP = iframeContent.querySelectorAll('.content__gdpr p');
            if( contentGdprP ) {
              contentGdprP.forEach(p => {          
                p.style.cssText = "display: none !important;";
              });
            }              
          }
        } 

        const iframeBody = iframeDoc.body;         
      
        if (!iframeBody || iframeBody.innerHTML.trim() === '') {
          
          openNewsletter.classList.add('hide');
          mcModal.classList.remove('active');
          document.getElementById('PopupSignupForm_0').style.display = 'none';
          console.log('Iframe body has no content.');
        }
      }
      clearInterval(checkMC);
    }
  }, 200);

  // UPSELL POP UP styling
  if (document.body.className.includes('template-product') ) {
    
    if( Weglot ) {  // Weglot 4 upsell popup
      Weglot.initialize({
          api_key: "wg_fafb1e1b62d3be2d24a0c9855efe51455",
          translate_iframes: ["#widget"]
      });
    }

  //   const observerUpsell = new MutationObserver((mutationsList, observer) => {
      
  //     const upsellContent = document.querySelector('.cb-widget-content');
  //     if( upsellContent ) {
        
  //       const upsellIframe = upsellContent.querySelector('iframe');
        
  //       if( upsellIframe ) {
          
  //         let iframeUpsellDoc = upsellIframe.contentDocument || upsellIframe.contentWindow.document;

  //         if( iframeUpsellDoc ) {

  //           const style = iframeUpsellDoc.createElement('style');
  //           style.textContent = `
  //             @font-face {
  //               font-family: 'Optima LT Pro';
  //               src: url('https://carlopignatelli.com/cdn/shop/files/OptimaLTPro-Roman.woff2') format('woff2'),
  //                    url('https://carlopignatelli.com/cdn/shop/files/OptimaLTPro-Roman.woff') format('woff');
  //               font-weight: normal;
  //               font-style: normal;
  //             }

  //             body .bgybHl {
  //               height: 100%;
  //             }
              
  //           `;
  //           iframeUpsellDoc.head.appendChild(style);
  //         }
  //       }
  //       observerUpsell.disconnect();
  //     }
  //   });
  //   observerUpsell.observe(document.body, { childList: true, subtree: true }); 
  }


  if (body.className.includes('template-page-ecom-catalogo-collezioni-2025') ) {

    const newAnimation = [{
        css: 'translateY',
        value: {
            trigger_start: 0,
            trigger_end: 50,
            start: '-60px',
            end: '0px'
        }
    }];
    
    const p1 = document.querySelector('.ecom-x97c7k82yfi');
    if( p1 ) {
      const currentAnimation = JSON.parse(p1.getAttribute('ecom-scrolling-animation'));
      p1.setAttribute('ecom-scrolling-animation', JSON.stringify(newAnimation));
    }

    const p2 = document.querySelector('.ecom-mtlrgr9yii');
    if( p2 ) {
      const currentAnimation = JSON.parse(p2.getAttribute('ecom-scrolling-animation'));
      p2.setAttribute('ecom-scrolling-animation', JSON.stringify(newAnimation));
    }

    const p3 = document.querySelector('.ecom-88ox19h97jv');
    if( p3 ) {
      const currentAnimation = JSON.parse(p3.getAttribute('ecom-scrolling-animation'));
      p3.setAttribute('ecom-scrolling-animation', JSON.stringify(newAnimation));
    }
  }


});